// Single GSAP registration file (see .claude/GSAP_GUIDELINES_WORDPRESS.md §1).
// Every module imports gsap/ScrollTrigger from here — never from the package
// directly — so plugins are registered exactly once.
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Prevent pin-jump when the mobile address bar shows/hides.
ScrollTrigger.config({ ignoreMobileResize: true });

export const PREMIUM_EASE = 'power3.out';
export const REVEAL_DISTANCE = 28; // px

export const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export { gsap, ScrollTrigger };
